export default "__VITE_ASSET__D2wD1_ec__"